module.exports = [{
      plugin: require('C:/Users/Adrian/Documents/ThunderLandings/BoringMagicCom/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/Adrian/Documents/ThunderLandings/BoringMagicCom/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
